<template>
  <div class="main-tree">
    <ul class="main-list">
      <div class="alert" v-if="getNotSyncServers.length === 1">
        {{ $t('navigation.configTree.server') + " " + notSyncNames + " " + $t('navigation.configTree.notExported') }}
      </div>
      <div class="alert" v-else-if="getNotSyncServers.length > 1">
        {{ $t('navigation.configTree.servers') + " " + notSyncNames + " " + $t('navigation.configTree.notExportedPlural') }}
      </div>

      <el-card class="box-card">
        <tree-node
          v-for="(node, index) in getConfigTree"
          :key="index"
          :node="node"
        ></tree-node>
      </el-card>
    </ul>
  </div>
</template> 



<script>
import TreeNode from "./TreeNode";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      notSyncNames: "",
    };
  },
  components: {
    TreeNode,
  },
  computed: {
    ...mapGetters(["getConfigTree", "getNotSyncServers", "getServersArray"]),
  },
  watch: {
    getNotSyncServers() {
      this.notSyncNames = "";
      for (let ns of this.getNotSyncServers) {
        let serverName = this.getServersArray.find((s) => s.id === ns).name;
        this.notSyncNames += serverName + " ";
      }
    },
  },
};
</script>


<style scoped>
.box-card {
  margin-top: 20px;
  margin-left: 5px;
  max-height: 75vh;
  overflow-y: auto;
  scrollbar-color: grey lightgrey;
  scrollbar-width: auto;
}
.box-card::-webkit-scrollbar {
  width: 10px;
}

.box-card::-webkit-scrollbar-track {
  background-color: lightgrey;
}

.box-card::-webkit-scrollbar-thumb {
  background-color: grey;
}
.alert {
  background-color: var(--active-color);
  padding: 5px 10px;
  margin: 3px 5px;
  border-radius: 5px;
  font-weight: 600;
  cursor: default;
  color: white;
}
</style>